import type { WebsocketMessage } from '@/types';
import { useWebsocketStore } from '@/websocket/websocket';

export function createWebsocketMessage(action: string, data: object, clientID: string | undefined): WebsocketMessage {
  const websocketStore = useWebsocketStore();

  const current_id = websocketStore.id;
  websocketStore.id++;

  return {
    id: current_id,
    action: action,
    data: data,
    rtoken: websocketStore.rtoken,
    clientid: clientID
  };
}
